import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';
import { Platform } from '@angular/cdk/platform';
import { BootstrapGridBreakpoints, BreakpointsService } from '../../services/breakpoints.service';
import { ProductAttribute } from '../../../graphql/generated/generated-types';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-item-list-params',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './item-list-params.component.html',
  styleUrl: './item-list-params.component.scss'
})
export class ItemListParamsComponent implements OnDestroy, OnInit {
  @Input() attributes: ProductAttribute[] = [];
  public itemLimit: number = 8;

   subscriptions: Subscription[] = [];

  constructor(private breakpointsService: BreakpointsService, private platform: Platform) {}

  ngOnInit(): void {
    if (this.platform.isBrowser) {
      this.subscribeToBreakpoint(BootstrapGridBreakpoints.LGLabel, 8);
      this.subscribeToBreakpoint(BootstrapGridBreakpoints.MDlabel, 6);
      this.subscribeToBreakpoint(BootstrapGridBreakpoints.SMlabel, 4);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  private subscribeToBreakpoint(breakpointLabel: BootstrapGridBreakpoints, limit: number): void {
    const subscription = this.breakpointsService.isBreakpointOrLower(breakpointLabel as any).subscribe({
      next: (matches: boolean) => {
        if (matches) {
          this.itemLimit = limit;
        }
      }
    });
    this.subscriptions.push(subscription);
  }
}
